module.exports = __webpack_public_path__ + "static/badgebackground-1bdd8ef64a5f428122f681b5c6808b7e.png";